import { useMemo, useSyncExternalStore } from 'react';
import type { LobbySession } from './LobbySession.js';
import type { CluegivingView } from '../clue-giving/types.js';

export interface UseCluegivingSessionResult {
  /** Non-null only while the session is in the ClueGiving phase. */
  view: CluegivingView | null;
  onSubmitClue: (text: string) => void;
}

export function useCluegivingSession(session: LobbySession): UseCluegivingSessionResult {
  const snapshot = useSyncExternalStore(
    (cb) => session.subscribe(cb),
    () => session.getSnapshot(),
  );
  const onSubmitClue = useMemo(
    () => (text: string) => session.sendSubmitClue(text),
    [session],
  );
  return { view: snapshot.cluegivingView, onSubmitClue };
}
